
<div class="rm-header">
    <span style="font-size: x-large;">Add Primary Contact Person</span>
</div>
<mat-dialog-content>
    <form [formGroup]="fg">
        <div class="col-12 pt-2 pb-2">
            <p>
                Please input the data pertaining to the primary contact person for the KYC.
            </p>
        </div>
        <div class="row pt-2">
            <!--      row-->
            <div class="col-6">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input matInput type="text" required formControlName="firstName">
                    <mat-error *ngIf="fg.get('firstName')?.hasError('required')">Field is required</mat-error>
                </mat-form-field>
            </div>
            <!--      row-->
            <div class="col-6">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matInput type="text" required formControlName="lastName">
                    <mat-error *ngIf="fg.get('lastName')?.hasError('required')">Field is required</mat-error>
                </mat-form-field>
            </div>
            <!--      row-->
            <div class="col-12">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Email Address</mat-label>
                    <input id="email" matInput type="text" required
                        placeholder="e.g. you@example.com" formControlName="email">
                    <mat-error *ngIf="fg.get('email')?.hasError('required')">Field is required</mat-error>
                    <mat-error *ngIf="fg.get('email')?.hasError('email')">Should be a valid email address</mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="space-between">
    <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" type="submit" [mat-dialog-close]="fg.value"
            [disabled]="fg.invalid">Submit</button>
</mat-dialog-actions>
  